// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2TBzc","overflowing":"ReadFullNote_overflowing__3BltG"};